<template>
  <router-view />
</template>

<style lang="scss">
@import "@/scss/style.scss";
</style>
